var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "background--text text--lighten-5 subheading" },
        [_vm._v("\n\t\tWorkflow\n\t")]
      ),
      _vm._v(" "),
      _c(
        "v-autocomplete",
        {
          ref: "jd_selector",
          staticClass: "mt-0 mb-1 py-0 grv-input",
          attrs: {
            loading: _vm.loading,
            clearable: "",
            "return-object": "",
            autofocus: "",
            "hide-details": "",
            "item-text": "label",
            "menu-props": { contentClass: "grv-menu" },
            "open-on-clear": "",
            solo: "",
            items: _vm.jds || [],
            "persistent-hint": "",
            value: _vm.jd_selected
          },
          on: {
            change: function($event) {
              return _vm.$emit("change", $event)
            }
          },
          scopedSlots: _vm._u([
            {
              key: "selection",
              fn: function(data) {
                return [
                  _c(
                    "v-chip",
                    {
                      staticClass: "mr-2 pa-0",
                      attrs: { color: "background", small: "", label: "" }
                    },
                    [_vm._v("\n\t\t\t\t#" + _vm._s(data.item.id) + "\n\t\t\t")]
                  ),
                  _vm._v("\n\t\t\t" + _vm._s(data.item.label) + "\n\t\t\t"),
                  data.item.archived > 0
                    ? _c(
                        "v-chip",
                        {
                          staticClass: "ml-2 pa-0",
                          attrs: {
                            color: "warning black--text",
                            small: "",
                            label: ""
                          }
                        },
                        [_vm._v("\n\t\t\t\tArchivé\n\t\t\t")]
                      )
                    : _vm._e()
                ]
              }
            },
            {
              key: "item",
              fn: function(data) {
                return [
                  _c(
                    "v-list-tile-avatar",
                    [
                      _c(
                        "v-chip",
                        {
                          staticClass: "mr-2",
                          attrs: { label: "", color: "background" }
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t" + _vm._s(data.item.id) + "\n\t\t\t\t"
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-list-tile-content",
                    [
                      _c("v-list-tile-title", [
                        _vm._v(
                          "\n\t\t\t\t\t" +
                            _vm._s(data.item.label) +
                            "\n\t\t\t\t"
                        )
                      ]),
                      _vm._v(" "),
                      _c("v-list-tile-sub-title", { staticClass: "caption" }, [
                        _vm._v(
                          "\n\t\t\t\t\t" +
                            _vm._s(data.item.description || "-") +
                            "\n\t\t\t\t"
                        )
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-list-tile-action",
                    { staticStyle: { display: "contents" } },
                    [
                      _c(
                        "span",
                        { staticStyle: { "min-width": "24px" } },
                        [
                          data.item.archived
                            ? _c(
                                "v-icon",
                                {
                                  attrs: { title: "Archivé", color: "warning" }
                                },
                                [_vm._v("\n\t\t\t\t\t\tarchive\n\t\t\t\t\t")]
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        { staticStyle: { "min-width": "24px" } },
                        [
                          data.item.restricted
                            ? _c(
                                "v-icon",
                                {
                                  attrs: {
                                    title: "Restreint aux administrateurs",
                                    color: "info"
                                  }
                                },
                                [_vm._v("\n\t\t\t\t\t\tsecurity\n\t\t\t\t\t")]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ]
                  )
                ]
              }
            }
          ])
        },
        [
          _vm._v(" "),
          _vm._v(" "),
          _c(
            "template",
            { slot: "append-outer" },
            [
              _vm.versions.length > 0
                ? _c(
                    "v-menu",
                    {
                      attrs: {
                        "content-class": "grv-menu",
                        "nudge-width": 200,
                        "offset-y": ""
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "activator",
                            fn: function(ref) {
                              var on = ref.on
                              return [
                                _c(
                                  "v-btn",
                                  _vm._g(
                                    {
                                      staticClass:
                                        "text-none color--text font-weight-bold version-btn",
                                      attrs: {
                                        large: "",
                                        loading: _vm.loading_versions,
                                        color: _vm.jd_selected_version_is_last
                                          ? "green accent-3"
                                          : "warning"
                                      }
                                    },
                                    on
                                  ),
                                  [
                                    _vm.jd_version_selected
                                      ? _c("span", { staticClass: "ml-1" }, [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\tv " +
                                              _vm._s(
                                                _vm.jd_version_selected
                                                  .version_number
                                              ) +
                                              "\n\t\t\t\t\t\t"
                                          )
                                        ])
                                      : _vm._e()
                                  ]
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        3201977171
                      ),
                      model: {
                        value: _vm.versions_menu,
                        callback: function($$v) {
                          _vm.versions_menu = $$v
                        },
                        expression: "versions_menu"
                      }
                    },
                    [
                      _vm._v(" "),
                      _c(
                        "v-card",
                        [
                          _c(
                            "v-list",
                            { staticClass: "background darken-1" },
                            _vm._l(_vm.versions, function(version) {
                              return _c(
                                "v-list-tile",
                                {
                                  key: version.version_number,
                                  class: _vm.getVersionColor(
                                    version.version_number
                                  ).text,
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      _vm.version_num = version.version_number
                                      _vm.versions_menu = false
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "v-list-tile-action",
                                    [
                                      _c("v-switch", {
                                        attrs: {
                                          color: _vm.getVersionColor(
                                            version.version_number
                                          ).switch,
                                          value: version.version_number
                                        },
                                        model: {
                                          value: _vm.version_num,
                                          callback: function($$v) {
                                            _vm.version_num = $$v
                                          },
                                          expression: "version_num"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-list-tile-content",
                                    [
                                      _c("v-list-tile-title", [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t\t\tv " +
                                            _vm._s(version.version_number) +
                                            "\n\t\t\t\t\t\t\t\t"
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "v-list-tile-sub-title",
                                        {
                                          staticStyle: {
                                            opacity: ".7",
                                            color: "inherit"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t\t\t" +
                                              _vm._s(
                                                version.version_description
                                              ) +
                                              "\n\t\t\t\t\t\t\t\t"
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm._t("jd-append")
            ],
            2
          )
        ],
        2
      ),
      _vm._v(" "),
      _vm._l(_vm.jd_selected_hint, function(desc, i) {
        return _c(
          "div",
          {
            key: "desc_" + i,
            staticClass: "caption background--text text--lighten-5"
          },
          [_vm._v("\n\t\t" + _vm._s(desc) + "\n\t")]
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e6e4274e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e6e4274e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./build/scramble/app-loader.js!./src/pages/maestro/launcher/launcher_jds_menu.vue
// module id = null
// module chunks = 